import { render, staticRenderFns } from "./SlideTypeItem.vue?vue&type=template&id=a4e34ba4&scoped=true"
import script from "./SlideTypeItem.vue?vue&type=script&lang=js"
export * from "./SlideTypeItem.vue?vue&type=script&lang=js"
import style0 from "./SlideTypeItem.vue?vue&type=style&index=0&id=a4e34ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e34ba4",
  null
  
)

export default component.exports